import * as React from "react"
import * as styles from "./styles.module.scss"
import iconToolsOfTrade from "./img/icon-tools-of-trade.svg"
import iconSunMoon from "./img/icon-sun-moon.svg"
import iconHealth from "./img/icon-health.svg"
import iconFood from "./img/icon-food.svg"
import iconCompensation from "./img/icon-compensation.svg"
import iconCommunityFeel from "./img/icon-community-feel.svg"
import LinkUnderline from "../LinkUnderline"

const WorkBetter: React.FC = () => {
  return (
    <section className={styles.dictionary}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Work Better</h2>
        </div>
        <ul className={styles.list}>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={iconSunMoon}
                alt="Life/work icon"
              />
            </figure>
            <h4 className={styles.itemHeading}>Life/work, not work/life</h4>
            <p className={styles.description}>
              All work and no play is a recipe for a breakdown. So we give our
              team members unlimited time off.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={iconCommunityFeel}
                alt="Community feel icon"
              />
            </figure>
            <h4 className={styles.itemHeading}>Community feels</h4>
            <p className={styles.description}>
              Happy hours, birthday parties, book clubs, and more. We believe in
              building a community, not just a company.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={iconToolsOfTrade}
                alt="Tools of trade icon"
              />
            </figure>
            <h4 className={styles.itemHeading}>Tools of the trade</h4>
            <p className={styles.description}>
              From{" "}
              <a href="https://www.themuse.com/companies/bettermortgage/office">
                <LinkUnderline>cozy couches</LinkUnderline>
              </a>{" "}
              to new computers, Better provides whatever you need to help us
              succeed.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={iconHealth}
                alt="Full health bars icon"
              />
            </figure>
            <h4 className={styles.itemHeading}>Full health bars</h4>
            <p className={styles.description}>
              We take care of our own. Better offers fully funded health,
              dental, and vision benefits, as well as a 401k plan and up to 20
              weeks paid parental leave.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img className={styles.image} src={iconFood} alt="Food icon" />
            </figure>
            <h4 className={styles.itemHeading}>Food for days</h4>
            <p className={styles.description}>
              Hungry employees aren’t happy employees. That’s why Better team
              members get free lunch, dinner, and snacks. Every. Single. Day.
            </p>
          </li>
          <li className={styles.item}>
            <i className={styles.lineEyebrow} />
            <figure className={styles.figure}>
              <img
                className={styles.image}
                src={iconCompensation}
                alt="Compensation icon"
              />
            </figure>
            <h4 className={styles.itemHeading}>Competitive compensation</h4>
            <p className={styles.description}>
              Cash and equity. If you care about that sort of thing. Which we
              do.
            </p>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default WorkBetter
